// Incorporadora / VENDEDORA por empreendimento.
//
// O dado "de verdade" que vai pro contrato está no .docx de cada modelo
// (modelos_contrato) — isto aqui é só o que as telas de detalhe (Contratos,
// Propostas) exibem. Cada empreendimento tem sua própria SPE:
//   • Ingarden              → TREEINGA INCORPORAÇÃO IMOBILIÁRIA SPE LTDA
//   • Lumière Residence Club → QUADRINGÁ INCORPORAÇÃO IMOBILIÁRIA SPE LTDA
// As duas SPEs são representadas pela mesma pessoa (Leonardo Fagner Botega).

export const TREEINGA = {
  razao_social: 'TREEINGA INCORPORAÇÃO IMOBILIÁRIA SPE LTDA',
  cnpj: '38.486.020/0001-97',
};

export const QUADRINGA = {
  razao_social: 'QUADRINGÁ INCORPORAÇÃO IMOBILIÁRIA SPE LTDA',
  cnpj: '59.200.694/0001-53',
  endereco: 'Av. Euclides da Cunha, 1347, Zona 05, CEP 87.015-180, Maringá/PR',
};

// Representante comum às SPEs (administrador / sócio).
export const REPRESENTANTE = {
  nome: 'Leonardo Fagner Botega',
  cpf: '048.762.131-38',
  email: 'leonardo@inbaseconstrutora.com',
  whatsapp: '(44) 99865-2663',
};

// Resolve a incorporadora pelo nome do empreendimento do contrato/proposta.
// Default = TREEINGA (Ingarden e qualquer coisa não mapeada).
export function incorporadoraDe(empreendimentoNome = '') {
  const n = String(empreendimentoNome || '').toLowerCase();
  if (n.includes('lumi')) return QUADRINGA; // "Lumière Residence Club"
  return TREEINGA;
}
